export class TripType{
    tripTypeId: string;
    tripTypeName: string;
    needApproval: boolean;
    isActive: boolean;
    createdOn?: Date;
    createdBy: string;
    modifiedOn?: Date;
    modifiedBy: string;
}